function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-486 -452) translate(487 453)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 17,
  r: 17,
  stroke: "#E8ECEF"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#E8ECEF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.877 0C4.723 0 2.97 1.752 2.97 3.905v6.637c0 2.153 1.752 3.905 3.906 3.905 2.153 0 3.905-1.762 3.905-3.928V3.905C10.782 1.752 9.03 0 6.877 0zm2.55 10.52c0 1.418-1.144 2.573-2.55 2.573-1.407 0-2.551-1.145-2.551-2.551V3.905c0-1.406 1.144-2.55 2.55-2.55 1.407 0 2.551 1.144 2.551 2.55v6.614zM6.199 16.411H7.553V19.481H6.199z",
  transform: "translate(10 7)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.676 18.646H4.077c-.374 0-.677.303-.677.677 0 .374.303.677.677.677h5.599c.374 0 .677-.303.677-.677 0-.374-.303-.677-.677-.677zM12.588 7.2c-.374 0-.678.304-.678.678v2.664c0 2.775-2.258 5.034-5.033 5.034-2.776 0-5.034-2.259-5.034-5.034V7.878c0-.374-.303-.677-.677-.677-.375 0-.678.303-.678.677v2.664c0 3.522 2.866 6.388 6.389 6.388 3.522 0 6.388-2.866 6.388-6.388V7.878c0-.374-.303-.677-.677-.677z",
  transform: "translate(10 7)"
})))));

var SvgMic = function SvgMic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mic.18165591.svg";
export { ForwardRef as ReactComponent };